module.exports = "<p>\n  posts works!\n</p>\n"